// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "client-editor/" + (chunkId === 634 ? "RootWidget" : chunkId) + ".chunk.min.js";
};